import React from "react";
import PropTypes from "prop-types";
import { numberFormatter } from "@/src/helpers/number-formatter";

const PriceE6t = ({ data: price }) => {
  if (!price) return null;
  price.value = price?.value || price?.price;
  const alternativeValue = price.alternativeValue == null ? "" : price.alternativeValue;
  const visiblePrice = price.value == null ? alternativeValue : numberFormatter(price.value);
  const visiblePriceCurrency = price.value === null ? "" : price.currency;

  return <span>{`${visiblePrice} ${visiblePriceCurrency}`}</span>;
};

PriceE6t.propTypes = {
  data: PropTypes.object,
};

export default PriceE6t;
